import { render } from "./EntryDetails.vue?vue&type=template&id=2b736aec"
import script from "./EntryDetails.vue?vue&type=script&lang=js"
export * from "./EntryDetails.vue?vue&type=script&lang=js"

import "./EntryDetails.vue?vue&type=style&index=0&id=2b736aec&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__